import React, { useEffect } from "react";
import AppLayout from "@amzn/meridian/app-layout";
import ErrorBoundary from "src/components/shared/errorBoundary/errorBoundary";
import { useAppSelector, useAppDispatch } from "src/store/store";
import { getUser, getAuditPermission } from "src/store/userSlice";
import Header from "src/components/shared/header/header";
import MainContent from "src/components/shared/mainContent/mainContent";
import { getModels } from "src/store/modelManagementSlice";
import SiteToaster from "src/components/shared/siteToaster/siteToaster";
import Alert from "@amzn/meridian/alert";
import Link from "@amzn/meridian/link";
import { isProd } from "src/utils/permissionUtil";
import { KatSpinner } from "@amzn/katal-react";
import Loader from "@amzn/meridian/loader";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";

const App = () => {
  const dispatch = useAppDispatch();
  const { token } = useAppSelector((state) => state.user);
  const { showBatchErrorMessageBanner } = useAppSelector((state) => state.batchExtractionSlice);

  const login = async () => {
    if (!token) {
      await dispatch(getUser()).unwrap();
    }
    await dispatch(getModels()).unwrap();
    // Resolve the audit permissions-group role for config-surface gating.
    // Non-audit users 403 here; the thunk fails closed to no config access.
    dispatch(getAuditPermission());
  };

  /**
   * Only make the getUser() call if the user has agreed to the privacy modal
   * */
  useEffect(() => {
    login();
  }, []);

  return (
    <ErrorBoundary>
      {token ? (
        <AppLayout headerComponent={Header}>
          {!isProd() && showBatchErrorMessageBanner && (
            <Alert size="medium" type="warning">
              Dear Excavator Users, due to AWS infrastructure budget constraints, models not yet
              onboarded will have batch processing capacity reduced to 50 records per run starting
              April 14th. Please submit an{" "}
              <Link
                href={
                  "https://issues.amazon.com/issues/create?template=03c8f54f-db03-4e4d-a538-2250a678f5c8"
                }
              >
                onboarding request
              </Link>{" "}
              to avoid this reduction
            </Alert>
          )}
          <SiteToaster />
          <Header />
          <MainContent />
        </AppLayout>
      ) : (
        <Row width={"fill"} alignmentHorizontal="center">
          <Column height={"80vh"} alignmentVertical="center">
            <Loader />
          </Column>
        </Row>
      )}
    </ErrorBoundary>
  );
};

export default App;
